const ROUTE_COLOR_COUNT = 10;

// Leer al renderizar: una lectura al importar el modulo puede ocurrir antes
// de que se aplique el CSS. Las variables de respaldo se resuelven en el DOM.
export function getRoutePalette() {
  const style = typeof document === 'undefined'
    ? null
    : getComputedStyle(document.documentElement);

  return Array.from({ length: ROUTE_COLOR_COUNT }, (_, index) => {
    const token = `--route-${index + 1}-rgb`;
    const channels = style?.getPropertyValue(token).trim();
    return channels ? `rgb(${channels})` : `rgb(var(${token}))`;
  });
}

export function getRouteColor(index = 0) {
  const palette = getRoutePalette();
  return palette[index % palette.length];
}

// Asignar sobre todos los recorridos de la vista antes de filtrar u ocultar.
// Ordenar los IDs evita cambios de color si la API devuelve otro orden.
export function buildRouteColorMap(teamIds = []) {
  const palette = getRoutePalette();
  const sortedIds = [...new Set(teamIds.map(String))].sort();
  return new Map(sortedIds.map((teamId, index) => [teamId, palette[index % palette.length]]));
}

// Copia para presentacion: la respuesta original se conserva para confirmar.
// Los colores guardados por versiones anteriores no definen la paleta actual.
export function colorDistributionRoutes(result, colorByTeamId) {
  if (!result) return result;

  return {
    ...result,
    assignments: (result.assignments || []).map((assignment) => ({
      ...assignment,
      color: colorByTeamId.get(String(assignment.teamId))
    }))
  };
}
